import React from "react";
import TermsAndConditions from "./TermsAndConditions";

const ModalLogin = () => {
  return (
    <div id="wrapperEditGaleria" className="wrapperPgi">
      <div className="mt-1 mb-2 container containerPgi">
        <header>
          <h1>Terminos y condiciones</h1>
        </header>
        <section className="wrapperViewGalery">
          <TermsAndConditions />
        </section>
      </div>
    </div>
  );
};

export default ModalLogin;
